import React from "react";

import Top from './images/icons/up.png'
import Egypt from './images/icons/egypt.png'
import Dark from './images/icons/moon.png'
import Design from './images/elements/About/Design.png'

import location from './images/icons/location.png'
import picture from './images/icons/picture.png'
import chat from './images/icons/chat.png'
import date from './images/icons/date.png'

const About = () => (
  <div className="aboutpage">

    <div className="slider">
      <div className="slide">
        <h1>Lorem.</h1>
        <p>Lorem ipsum dolor sit amet.</p>
      </div>
      <div className="slide">
        <h1>Lorem.</h1>
        <p>Lorem ipsum dolor sit amet.</p>
      </div>
      <div className="slide">
        <h1>Lorem.</h1>
        <p>Lorem ipsum dolor sit amet.</p>
      </div>
    </div>

    <div className="container2">

      <div className="page">
        <div className="artbox">
          <h1> The Importance of the <u><i>10 Days</i> </u> of Dhul Hijjah </h1>
            <p className="p2">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque
              voluptate dicta autem maiores sapiente. Doloremque
            </p>
            <button lassName="button">Learn More</button>
        </div>
        <div className="image"> <img src={Design} style={{ float: "right" }}/> </div>
      </div>

      <div className="page2">
        <h1>Lorem ipsum </h1>
        <div className="big-box">

          <div className="about-box">
            <div className="top-border"></div>
            <div className="bottom-border"></div>
            <img className="icons2" src={location}/>
            <div className="text">
              <h3>Lorem ipsum dolor</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit Natus
                molestias itaque deleniti Veritatis iure deleniti magni et qui
                laudantium non dolores eos perferendis recusandae
              </p>
            </div>
          </div>

            <div className="about-box">
            <div className="top-border"></div>
            <div className="bottom-border"></div>
            <img className="icons2" src={picture}/>
            <div className="text">
              <h3>Lorem ipsum dolor</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit Natus
                molestias itaque deleniti Veritatis iure deleniti magni et qui
                laudantium non dolores eos perferendis recusandae
              </p>
            </div>
          </div>

          <div className="about-box">
            <div className="top-border"></div>
            <div className="bottom-border"></div>
            <img className="icons2" src={chat}/>
            <div className="text">
              <h3>Lorem ipsum dolor</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit Natus
                molestias itaque deleniti Veritatis iure deleniti magni et qui
                laudantium non dolores eos perferendis recusandae
              </p>
            </div>
          </div>

          <div className="about-box">
            <div className="top-border"></div>
            <div className="bottom-border"></div>
            <img className="icons2" src={date}/>
            <div className="text">
              <h3>Lorem ipsum dolor</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit Natus
                molestias itaque deleniti Veritatis iure deleniti magni et qui
                laudantium non dolores eos perferendis recusandae
              </p>
            </div>
          </div>

        </div>
        <div className="p3">
          Lorem ipsum dolor sit amet consectetur adipisicing elit Voluptas
          ducimus qui unde earum provident facilis beatae rem inventore incidunt
          magnam veritatis doloribus porro adipisci nemo aut ut, minus dolorem
          officiis placeat rerum pariatur sint quis aperiam deserunt Provident
          earum sint facere ratione incidunt tempore, adipisci nihil placeat
          obcaecati sunt autem
        </div>
      </div>
    </div>

    <div className="features">
    <a href="#"> <img src={Top} width="40" style={{ border: 'none' }} id="toTop" className="test"/></a>
    <a href="#"> <img src={Egypt} width="40"/></a>
    <a href="#"> <img src={Dark} width="40"/></a>
    </div>

  </div>
);

export default About;